import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import useProfile from "@/hooks/use-profile";
import { useEffect } from "react";
import { EUserSuspendStatus } from "@/utilities/types/suspension";

import { useNavigate } from "react-router-dom";
import convertToSingaporeTime from "@/utilities/functions/convertToSingaporeTime";
import { routes } from "@/config/routes";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function WebsiteSuspended() {
  const { profile } = useProfile();
  const expiredDate = profile?.userSuspends?.[0].date;
  const navigate = useNavigate();

  useEffect(() => {
    if (profile?.userSuspends?.[0].status !== EUserSuspendStatus.ACTIVE) {
      navigate(routes.home);
    }
  }, [profile?.userSuspends?.[0].status]);

  return (
    <div className="min-h-screen bg-red-600 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-4 max-w-lg w-full text-center">
        {/* Warning Icon */}
        <div className="mb-6">
          <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto">
            <svg
              data-name="Layer 3"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 128 128"
              fill="yellow"
            >
              <path d="M70.335 30.683c-1.569-2.719-3.878-4.278-6.337-4.278s-4.764 1.556-6.333 4.274l-34.6 59.94c-1.569 2.719-1.765 5.5-.536 7.628s3.734 3.348 6.871 3.348h69.2c3.138 0 5.643-1.22 6.871-3.348s1.035-4.907-.534-7.624zm31.484 65.452c-.456.785-1.627 1.237-3.216 1.237H29.4c-1.589 0-2.76-.452-3.214-1.237s-.26-2.029.536-3.406l34.6-59.94c.794-1.375 1.769-2.163 2.676-2.163s1.886.79 2.68 2.167l34.6 59.939c.798 1.377.994 2.616.541 3.403z" />
              <path d="M64 78.144a2.11 2.11 0 0 0 2.111-2.111V48.24a2.111 2.111 0 0 0-4.222 0v27.793A2.11 2.11 0 0 0 64 78.144z" />
              <circle cx="64" cy="86.506" r="3.734" />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Website Suspended
        </h1>

        {/* Main Message */}
        <p className="text-gray-700 mb-2">
          This site is offline because the renewal was not completed on time.
          {expiredDate && (
            <>
              <br />
              <span className="text-red-600 font-semibold">
                Suspended on:{" "}
                {convertToSingaporeTime(new Date(expiredDate), "DD MMM YYYY")}
              </span>
            </>
          )}
          <br />
          If you are the owner, kindly contact ProjectSG immediately to
          reactivate your service. Failure to act will result in continued
          downtime and data loss.
        </p>

        {/* Contact Information */}
        <p className="text-gray-600 text-sm">
          Contact your developer for further information.
        </p>
      </div>
    </div>
  );
}
